import React from 'react';

import {
  Box,
  Grid,
  Theme,
  Typography,
  createStyles,
  makeStyles,
} from '@material-ui/core';

import { ReactComponent as Checked } from '../../../../../../assets/img/Checked.svg';
import FloatingButton from '../../../../../../components/FloatingButton';
import Loader from '../../../../../../components/LoaderSplash/Loader.component';
import { useSinisterInspectionsContext } from '../../../../../../context/SinisterInspections/SinisterInspections.provider';

const useStyle = makeStyles((theme: Theme) => createStyles({}));

const Step0 = () => {
  const classes = useStyle();
  const { loading, step, goBack, nextStep } = useSinisterInspectionsContext();

  return (
    <>
      <Box display={loading ? 'block' : 'none'}>
        <Loader action={'Cargando información'}></Loader>
      </Box>

      <Grid container justify="center">
        <Grid item xs={11}>
          <Box my={4}>
            <Typography variant="h6">
              Para evaluar los daños de tu vehículo debemos inspeccionarlo
            </Typography>
          </Box>
          <Box my={2}>
            <Typography>
              En caso que prefieras o cuentes con algún taller de tu elección:
            </Typography>
          </Box>
        </Grid>
      </Grid>

      <Grid container justify="center">
        <Grid item xs={11}>
          <Box mt={2} mb={3} style={{ display: 'flex' }}>
            <Box>
              <Checked></Checked>
            </Box>
            <Box style={{ marginLeft: '5px' }}>
              <Typography>
                Coordiná con ellos fecha de inspección con un plazo anticipado
                de 72 hs hábiles.
              </Typography>
            </Box>
          </Box>
          <Box mt={2} mb={3} style={{ display: 'flex' }}>
            <Box>
              <Checked></Checked>
            </Box>
            <Box style={{ marginLeft: '5px' }}>
              <Typography>
                Agendá por ésta vía tu turno y un inspector de Galicia Seguros,
                visitará el taller que nos indiques.
              </Typography>
            </Box>
          </Box>
          <Box mt={2} mb={3} style={{ display: 'flex' }}>
            <Box>
              <Checked></Checked>
            </Box>
            <Box style={{ marginLeft: '5px' }}>
              <Typography>
                Si ya tienes prespuesto de tu taller, subí fotos del mismo, al
                agendar la visita del inspector.
              </Typography>
            </Box>
          </Box>
        </Grid>

        <Grid item xs={12}>
          <Box my={4}>
            <FloatingButton onClick={nextStep}> Continuar </FloatingButton>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default Step0;
